define([
	"dojo/_base/declare",
	"csi/heading/Refvector",
	"SiteAdmin/Locale"
], function(declare,Refvector,Locale) {

	return declare(Refvector, {
		getNodeDisplayName: function(/*Context*/ctx, /*Node*/node) {
			// summary: get the node display name. Allows to override display names in derived classes.
			return Locale.getConfigurableAttributeNodeName(node);
		}
	});
});